<a
  [href]="payload().url"
  target="_blank"
  rel="noopener noreferrer"
  class="inline-block w-full cursor-pointer rounded-full border px-4 py-2.5 text-center text-sm font-semibold tracking-wide transition-all duration-200 hover:bg-[color-mix(in_srgb,var(--bot-secondary,#004251)_30%,transparent)]"
  style="
    background-color: color-mix(in srgb, var(--bot-secondary, #004251) 20%, transparent);
    border-color: var(--bot-secondary, #004251);
    color: var(--bot-secondary, #004251);
  "
>
  {{ payload().label }}
</a>
